import { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import "./style.scss";

export const FixedTypography = ({ className, children, height = 110 }) => {
  const containerRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (el) {
      setOverflowing(el.scrollHeight > el.clientHeight);
    }
  }, [children]);

  useEffect(() => {
    const el = containerRef.current;
    const onScroll = (e) => {
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 35) {
        setOverflowing(false);
      }
    };

    el.addEventListener("scroll", onScroll);

    return () => {
      el.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <Typography
      ref={containerRef}
      className={`${className} shadow-container${
        overflowing ? " overflowing" : ""
      }`}
      style={{ maxHeight: height }}
    >
      {children}
      <span className="bottom-shadow" />
    </Typography>
  );
};

FixedTypography.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  height: PropTypes.number,
};
